import './vendor';
import helpers from './helpers';
import {showFixedMenu, showDevForm, hideForm, updateThumbnail, toggleIcon} from './functions';
import Swiper, {Scrollbar, Pagination} from 'swiper';

Swiper.use([Scrollbar, Pagination]);

const body = $('body')[0].classList;

showFixedMenu();

const $burger = $('.menu-hamburger__btn input');

$('.js-menu-link').on('click', (e) => {
	e.preventDefault();
	helpers.scrollTo($(`${$(e.currentTarget).attr('href')}`), 500, -75);

	if ($burger[0].checked) {
		$burger[0].click();
	}

	hideForm();
});

// fixed menu
$(window).on('scroll', () => {
	showFixedMenu();
});

// insert data and open popup
$('.js-developer-btn').on('click', (e) => {
	e.stopPropagation();

	const el = $(e.currentTarget);

	body.add('scroll-hidden');

	$('.menu-hamburger__btn input')[0].checked = true;

	showDevForm(el.children('.developer-card__title')[0].textContent,
		el.children('.developer-card__text')[0].innerHTML);
});

// close popup
$('.js-popup-close, .popup__shadow, .js-menu-link').on('click', (e) => {
	e.stopPropagation();

	if ($burger[0].checked) {
		$burger[0].click();
	}

	body.remove('scroll-hidden');

	hideForm();
});

//	eslint-disable-next-line
let scrollbar = new Swiper('.partners__wrapper', {
	slidesPerView: 'auto',
	watchSlidesVisibility: true,
	scrollbar: {
		el: '.swiper-scrollbar',
		draggable: true,
	},
});

//	eslint-disable-next-line
let pagination = new Swiper('.media__wrapper', {
	breakpoints: {

		320: {
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 16,
			loopedSlides: 'auto',

			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
		},

		680: {
			slidesPerView: 2,
			spaceBetween: 20,
		},

		1025: {
			slidesPerView: 3,
			slidesPerGroup: 3,
			spaceBetween: 20,
			watchSlidesVisibility: true,
			pagination: {
				el: '.media-pagination',
				clickable: true,
			},
		},
	},
});

// drag and drop
const inputElement = document.querySelector('.welcome-form-file__input');
const dropZoneElement = document.querySelector('.welcome-form-file__label');

inputElement.addEventListener('change', () => {
	if (inputElement.files.length) {
		updateThumbnail(dropZoneElement, inputElement.files[0]);
		toggleIcon();
	} else {
		const s = 'Загрузить резюме';
		document.querySelector('.js-form-filename').textContent = s;
		document.querySelector('.welcome-form-file__label-mobile span').textContent = s;
	}
});

dropZoneElement.addEventListener('dragover', (e) => {
	e.preventDefault();
	dropZoneElement.classList.add('drop-zone--over');
});

['dragleave', 'dragend'].forEach((type) => {
	dropZoneElement.addEventListener(type, () => {
		dropZoneElement.classList.remove('drop-zone--over');
	});
});

dropZoneElement.addEventListener('drop', (e) => {
	e.preventDefault();

	if (e.dataTransfer.files.length) {
		inputElement.files = e.dataTransfer.files;
		updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
	}

	dropZoneElement.classList.remove('drop-zone--over');
});

// menu-mobile
$('.menu-hamburger__btn').on('click', () => {
	if (!$('.popup')[0].classList.contains('is-active')) {
		$('.js-menu')[0].classList.toggle('is-active');
	} else {
		hideForm();
	}

	body.toggle('scroll-hidden');
});

// validate input
$('#name').on('input', (e) => {
	// eslint-disable-next-line
	e.currentTarget.value = e.currentTarget.value.replace(/[0-9]+/g, '');
});

$('#phone').on('input', (e) => {
	// eslint-disable-next-line
	e.currentTarget.value = e.currentTarget.value.replace(/[a-zA-Zа-яА-Я]+/g, '');
});

// send form

$('.welcome-form__btn').on('click', (e) => {
	e.preventDefault();
	e.stopPropagation();

	const requiredFields = ['name', 'phone', 'email', 'pdn'];
	let error = false;
	let sendData = new FormData();

	$('.welcome-form input, .welcome-form textarea').each((i, el) => {
		if (el.type !== 'checkbox') {
			if (el.type === 'file') {
				sendData.append(el.id, el.files[0]);
			} else {
				sendData.append(el.id, el.value.trim());
			}
		}

		if (requiredFields.indexOf(el.id) !== -1) {
			el.classList.remove('is-error');

			if (el.type === 'checkbox') {
				if (!el.checked) {
					el.classList.add('is-error');
					error = true;
				}
			} else if (el.value.length === 0) {
				el.classList.add('is-error');
				error = true;
			}
		}
	});

	if (error) {
		return false;
	}

	$.ajax({
		url: 'send.php',
		type: 'POST',
		contentType: false,
		processData: false,
		data: sendData,
		dataType: 'json',
	})
		.done((response) => {
			body.add('scroll-hidden');
			if (window.innerWidth < 1025) {
				$('.menu-hamburger__btn input')[0].checked = true;
			}
			if (response.success) {
				showDevForm('Спасибо', 'Мы скоро свяжемся с вами', '#thanks');
			} else {
				showDevForm('Что-то пошло не так', response.text, '#thanks');
			}
		})
		.fail(() => {
			body.add('scroll-hidden');
			if (window.innerWidth < 1025) {
				$('.menu-hamburger__btn input')[0].checked = true;
			}
			showDevForm('Извините', 'Произошла какая-то ошибка', '#thanks');
		});

	return true;
});
